// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import canvasConfig from "./utils/canvasConfig";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//引入amimation
import "animate.css"
// 引入样式
import 'vue-easytable/libs/themes-base/index.css'
import 'swiper/dist/css/swiper.css'
// 导入 table 和 分页组件
import { VTable, VPagination } from 'vue-easytable'
//customized global call component

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard)


import requireModal from "./components/requirementModal"
Vue.$requireModal = Vue.prototype.$requireModal = requireModal;

// import Tip from "./components/tip"
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)

Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)

//global emit-component
// Vue.$Tip = Vue.prototype.$Tip = Tip;


Vue.config.productionTip = false

//---------路由守卫 多时抽出为单文件

router.beforeEach((to, from, next) => {
  if (store.getters['user/isLogined'] && to.name === 'login') {
    //带路径参数进入页面时，后退不退回登陆页，进入首页
    next({ path: "/index" })
  } else if (to.name === 'movies' && to.query.statusCode === undefined && from.name === 'login') {
    //刷新页面进入没有statuscode的对比详情页面时，进入首页
    next({ path: "/index" })
  } else {
    next()
  }
})

//从影片对比页面后退时，清除store中影片数据,清除sessionStorage中的数据
router.afterEach((to, from) => {
  if (!['addCompaireMovies', 'login'].includes(to.name) && from.name === 'movies') {
    //销毁前数据清理
    store.commit("movie/clearMainMovie");
    store.commit("movie/clearMovieList");
    store.commit("movie/clearCycleMoviesList");
    store.commit("movie/clearMovieActive");
    //清除sessionStorage
    sessionStorage.removeItem('movie_compaire_detail')
  }
})
//进入影片对比页面，从sessionStorage中读取对比影片信息
router.afterEach((to, from) => {

})
//-----------------------------


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
